module.exports = __webpack_public_path__ + "img/questionmark.e4edf80a.svg";